module.exports = __webpack_public_path__ + "img/01.2070c9b8.jpg";